import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataService {
  private Objet = null;

  private dialogRef = new BehaviorSubject(this.Objet);

  SetDialogRef(value: MatDialogRef<any, any>): void {
    this.dialogRef.next(value);
  }

  GetDialogRef(): Observable<MatDialogRef<any, any>> {
    return this.dialogRef.asObservable();
  }

  GetDialogRefValue(): MatDialogRef<any, any> {
    return this.dialogRef.value;
  }

}
